import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

function Contact() {
  const { t } = useTranslation();
  return (
    <div>
      <div className="row banner" style={{ backgroundImage: 'url(./images/temple.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
      <div className="container" style={{ marginTop: '100px', marginBottom: '100px' }}>

        <div className="row">
          <div className="col-md-5" style={{ background: '#ffffffff', padding: '50px' }}>
            <div className="row" style={{ borderBottom: '0px solid orange', paddingBottom: '15px', paddingTop: '15px' }}>
              <h3 className="cheading" >Address</h3>
              {/* first */}
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-map-marker contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  <p className="addr">SUKAPURAM SREE DAKSHINAMOORTHY DEVASWOM <br />
(Malabar Devaswom Board) <br />
Sukapuram (PO) Edappal <br />
Malappuram (Dis) Kerala, 679576 </p>
                </div>
              </div>
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-phone-square contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  <p className="addr">98 95 27 20 32, 0494 2680032</p>
                </div>
              </div>
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-envelope contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  <p className="addr">dakshinamoorthy.temple@gmail.com</p>
                </div>
              </div>

            </div>
          </div>

          <div className="col-md-7" style={{ backgroundSize: 'cover', backgroundPosition: 'center' }}>
            {/* <p style={{fontFamily:'manjari',fontSize:'12pt',fontWeight:'700',lineHeight:'20pt'}}>
              പെരളശ്ശേരി ശ്രീ സുബ്രഹ്മണ്യസ്വാമി ക്ഷേത്രത്തിൽ നിന്നും അഞ്ചു കിലോമീറ്റർ ദൂരം
            </p> */}
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2013968.887086894!2d75.1656948536634!3d9.635418718736668!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7b96cc14a498f%3A0xf503aff105a8f183!2sSukapuram%20Sree%20Dakshinamurthy%20Temple%2C%20Edappal!5e0!3m2!1sen!2sin!4v1786556305324!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>


          </div>
        </div>


      </div>
    </div>
  );
}

export default Contact;

